import { ShortenEventScopeType } from '../shortenEventScopeTypeConstants';
import CalendarCloudSettings from '../store/schema/CalendarCloudSettings';
import { action } from 'satcheljs';

/**
 * Called to set the shouldEventsEndEarly property in store
 */
export const setShouldEventsEndEarly = action(
    'setShouldEventsEndEarly',
    (shouldEventsEndEarly: boolean | undefined) => ({
        shouldEventsEndEarly,
    })
);

/**
 * Called to set the shortenEventScope property in store
 */
export const setShortenEventScope = action(
    'setShortenEventScope',
    (shortenEventScope: ShortenEventScopeType | undefined) => ({
        shortenEventScope,
    })
);

/**
 * Called to set the endShortEventsBy property in store
 */
export const setEndShortEventsBy = action(
    'setEndShortEventsBy',
    (endShortEventsBy: number | undefined) => ({
        endShortEventsBy,
    })
);

/**
 * Called to set the endLongEventsBy property in store
 */
export const setEndLongEventsBy = action(
    'setEndLongEventsBy',
    (endLongEventsBy: number | undefined) => ({
        endLongEventsBy,
    })
);

/**
 * Called to populate the cloud settings in store
 */
export const updateCalendarCloudSettings = action(
    'updateCalendarCloudSettings',
    (calendarCloudSettings: CalendarCloudSettings) => ({
        calendarCloudSettings,
    })
);

/**
 * Called to set the enableOnlineMeetingsByDefault property in store
 */
export const setEnableOnlineMeetingsByDefault = action(
    'setEnableOnlineMeetingsByDefault',
    (enableOnlineMeetingsByDefault: boolean | undefined) => ({
        enableOnlineMeetingsByDefault,
    })
);
